<template>
  <case-actions
    class="case-monitor-procedures"
    :available-actions="monitorProcedures"
    :selected-actions="caseConf._treatments"
    :errors="errors"
    :warnings="warnings"
    :readonly="readonly"
    :disabled="isDisabled"
    color="green-3"
    @update="update"
  >
    <template slot="after-options-LEAD_SELECT-LEAD">
      <help-tooltip class="twelve-leads-tooltip" type="info">
        12 lead does not automatically generate in the Simulation.
        <br>Please add a 12 lead image in the {{ 'Media' | translateFeatureLabel }} section to make
        <br>it available in the Simulation.
      </help-tooltip>
    </template>
    <template slot="toggle-enabled-PACING">
      <help-tooltip class="action-enabled-tooltip" type="info">
        Make sure to include a Pacing Action and Pacing Effect in
        <br>case logic if Pacing is enabled in the Sim.
      </help-tooltip>
    </template>
    <template slot="toggle-disabled-PACING">
      <help-tooltip class="action-enabled-tooltip" type="info">
        Requires Pads enabled
      </help-tooltip>
    </template>
    <template slot="toggle-disabled-DEFIBRILLATION">
      <help-tooltip class="action-enabled-tooltip" type="info">
        Requires Pads enabled
      </help-tooltip>
    </template>
    <template slot="toggle-disabled-SYNC">
      <help-tooltip class="action-enabled-tooltip" type="info">
        Sync requires Defib enabled
      </help-tooltip>
    </template>
  </case-actions>
</template>

<script>
import get from 'lodash/get';

import HelpTooltip from '~lib/common/components/HelpTooltip';

import CaseActions from '../../common/CaseActions';

export default {
  name: 'case-monitor-procedures',
  components: {
    CaseActions,
    HelpTooltip,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    monitorProcedures: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    errors() {
      return get(
        this.$store.getters['validation/errorsByFieldAndId'],
        '_treatments',
      );
    },
    warnings() {
      return get(
        this.$store.getters['validation/visibleWarningsByFieldAndId'],
        '_treatments',
      );
    },
  },
  methods: {
    update(monitorProcedures) {
      this.$emit('update', { _treatments: monitorProcedures });
    },
    isDisabled(actionId, context) {
      if (['PACING', 'DEFIBRILLATION'].includes(actionId)) {
        // Don't let user turn defib on if leads/pads isn't on
        const leadValues = get(context.selectedActionsMap, 'LEAD_SELECT.options.componentOptions.LEAD.availableValues');
        const padsEnabled = context.isEnabled('LEAD_SELECT') && leadValues.includes('PADS');
        return !padsEnabled && !context.isEnabled(actionId);
      }
      else if (actionId === 'SYNC') {
        // Don't let user turn sync on if defib isn't on
        return !context.isEnabled('DEFIBRILLATION') && !context.isEnabled('SYNC');
      }
      return false;
    },
  },
};
</script>

<style scoped>
.action-enabled-tooltip {
  top: 8px;
}
.twelve-leads-tooltip, .action-enabled-tooltip {
  margin-left: 5px;
}
</style>
